/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable */

/**
 * PS_CR_1
 */
import {
  Grid,
  Typography,
  Card,
  CardContent,
  Box,
  RACToggle,
  useMediaQuery,
} from '@rentacenter/racstrap';
import React, { useContext, useState, useEffect, useRef } from 'react';
import { agreementContext } from '../context/PaymentInformationContext';
import { calculateTotalDueAmount } from '../utils/calculateTotalDueAmount';
import CurrencyInput from 'react-currency-input-field';
import { takePaymentStyles } from '../../stylesJS/makeStyles';
import {useTranslation} from 'react-i18next';
import {
  CarryRentInterface,
  carryToggleButtonEnableAndDisable,
} from '../interface/carryRentInterface';
import moment from 'moment';
import { calculateRemainingAmountDue } from '../utils/amountCalculations';
import { AgreementDetails } from '../interface/paymentInfoInterface';
import CONSTANTS from '../constants/constant';
/**
 * PS_CR_2
 * @returns
 */
export function CarryRent() {
  /**
   * PS_CR_3, PS_CR_4
   */
  const classes = takePaymentStyles();
  const{t}=useTranslation('BackRent');
  const agreementInfo = useContext(agreementContext);
  const [enableCarryRent, setEnableCarryRent] = useState<boolean>(false);
  const {featureFlags}=useContext(agreementContext);
  const [carryRentData, setCarryRentData] = useState<CarryRentInterface>({
    minPayment: CONSTANTS.ZERO_TWO_DECIMAL_NUMBER,
    maxCarryAmount: CONSTANTS.ZERO_TWO_DECIMAL_NUMBER,
  });
  const [carryAmount, setCarryAmount] = useState<string>(
    CONSTANTS.ZREO_TWO_DECIMAL_STRING
  );
  const[carryRentAmountDisable, setCarryRentAmountDisable] = useState<boolean>(false)
  const [carryToggleEnableAndDisable, setCarryToggleEnableAndDisable] =
    useState<carryToggleButtonEnableAndDisable>({
      // isInitialAndFinalAgreement: false,
      isAgreementSelected: false,
      isPendingAgrTransfer: false,
      diffStoreAgreement: false,
      isRevenueRecogActivated: false,
    });
  const isMediumScreen = useMediaQuery(
    '(min-width:600px) and (max-width:1280px)'
  );
  const bottomRef = useRef<any>(null);

  /**
   * PS_CR_5, PS_CR_6, PS_CR_7
   */

  useEffect(() => {
    const conditions = {
      isAgreementSelected: agreementInfo?.agreementDetails?.some(
        (agreementValue) => agreementValue.selected
      ),
      isPendingAgrTransfer: !!agreementInfo?.storeInfo?.storeDetails?.some(
        (storeValue) =>
          storeValue.storeNumber ==
            sessionStorage.getItem(CONSTANTS.STORE_NUMBER) &&
          storeValue.transferAgreementStatus
      ),
      diffStoreAgreement: agreementInfo?.agreementDetails?.some(
        (agreementValue) =>
          agreementValue.selected &&
          agreementValue.storeNumber !=
            sessionStorage.getItem(CONSTANTS.STORE_NUMBER)
      ),
      isRevenueRecogActivated:
        !!agreementInfo?.featureFlags?.RevenueRecognition,
    };
    setCarryToggleEnableAndDisable(conditions);
    if (
      !agreementInfo.customerInfo.carryRentEnable &&
      agreementInfo.customerInfo.carryRentToggleEnabled
    ) {
      handleToggle(false);
    }
  }, [agreementInfo.customerInfo, agreementInfo.agreementDetails]);

  useEffect(() => {
    if (agreementInfo.isSetToDefault !== CONSTANTS.ZERO_NUMBER) {
      setEnableCarryRent(false);
      agreementInfo.setCarryRent(CONSTANTS.ZREO_TWO_DECIMAL_STRING)
      agreementInfo.setPaymentDisable((prev) => ({
        ...prev,
        isValidCarryRent: false,
      }));
      setCarryAmount(CONSTANTS.ZREO_TWO_DECIMAL_STRING)
    }
  }, [agreementInfo.isSetToDefault]);

  useEffect(() => {
    if (enableCarryRent) {
      setTimeout(() => {
        window.scrollTo({
          top: document.documentElement.scrollHeight,
          behavior: 'smooth',
        });
      }, 1000);
    }
    if(isMediumScreen) {
      console.log('Inside the scroll')
      window.scrollTo(0, document.body.scrollHeight);
    }
  }, [enableCarryRent]);

  /**
   * PS_CR_9 - PS_CR_16
   * This function will calculate the Mininum payment amount
   */
  const calculateMinimumPayment = () => {
    let totalAmount: number = CONSTANTS.ZERO_NUMBER;
    let totalMaxCarryAmount: number = CONSTANTS.ZERO_NUMBER;

    agreementInfo.agreementDetails.map((agreementValue: AgreementDetails) => {
      const startDate = moment(agreementValue.currentDueDate);
      const endDate = moment(agreementValue.nextDueDate);
      const DaysDiffer = endDate.diff(startDate, 'days');
      if (agreementValue.selected) {
        const amountForSpecificAgreements =
          calculateTotalDueAmount(agreementValue).toString();
        totalAmount += parseFloat(
          amountForSpecificAgreements.includes(CONSTANTS.OPEN_BRACKET_STRING) &&
            amountForSpecificAgreements.includes(CONSTANTS.CLOSE_BRACKET_STRING)
            ? CONSTANTS.ZREO_TWO_DECIMAL_STRING
            : amountForSpecificAgreements
        );

        if (
          !CONSTANTS.BASIC_AGREEMENT_TYPE_ARRAY.includes(
            agreementValue.agreementType
          ) &&
          CONSTANTS.RENTAL_AGREEMENT_RTO.includes(
            agreementValue.agreementType) &&
          agreementValue.otherIncomeType == CONSTANTS.EMPTY_STRING &&
          agreementValue.numberOfPaymentsMade !== CONSTANTS.ZERO_NUMBER &&
          !agreementValue?.isFreeTimeEdit &&
          !agreementValue.isZeroPayment &&
          !CONSTANTS.ZERO_AND_ONE_ARRAY.includes(DaysDiffer)
        ) {
          totalMaxCarryAmount += calculatePerDayRent(agreementValue);
        }
      }
    });

    const calculatedResponse = calculateRemainingAmountDue(agreementInfo);
    const availCredits = Number(
      agreementInfo.customerInfo.amountUsed.webLeadUsed +
        agreementInfo.customerInfo.amountUsed.ipSuspenseUsed +
        agreementInfo.customerInfo.amountUsed.coaUsed
    );
    const totalMinAmount = totalAmount - availCredits;
    console.log(
      totalAmount,
      totalMinAmount,
      availCredits,
      totalMaxCarryAmount, 
      "amount calculation on min payment"
    );
    let finalTotalMaxCarryAmount: number = CONSTANTS.ZERO_NUMBER;
    if(Number(calculatedResponse.remainingAmount.toFixed(2)) <=  Number(carryAmount)){
      setCarryRentAmountDisable(true)
    }
    else{
      setCarryRentAmountDisable(false)
    }
    
    if (
      Number(carryAmount) !== CONSTANTS.ZERO_NUMBER
    ) {
      finalTotalMaxCarryAmount = Number(totalMaxCarryAmount.toFixed(2));
    } else if (
      Number(calculatedResponse.remainingAmount.toFixed(2)) >=
        CONSTANTS.ZERO_NUMBER &&
      Number(calculatedResponse.remainingAmount.toFixed(2)) <=
        Number(totalMaxCarryAmount.toFixed(2))
    ) {
      finalTotalMaxCarryAmount = Number(
        calculatedResponse.remainingAmount.toFixed(2)
      );
    } else {
      finalTotalMaxCarryAmount = Number(totalMaxCarryAmount.toFixed(2));
    }
    setCarryRentData({
      ...carryRentData,
      minPayment: totalMinAmount - totalMaxCarryAmount,
      maxCarryAmount: finalTotalMaxCarryAmount
    });
  };

  /**
   * PS_CR_18, PS_CR_19, PS_CR_20, PS_CR_21, PS_CR_22
   * This function will calculate the per day rent for indivigual agreement.
   * @param agreementRateDetails
   * @returns
   */
  const calculatePerDayRent = (agreementDetails) => {
    let calculatePerDayRent: number = CONSTANTS.ZERO_NUMBER;
    calculatePerDayRent +=
      parseFloat(
        agreementDetails.agreementRateDetails?.perDayRent
          ? agreementDetails.agreementRateDetails.perDayRent
          : CONSTANTS.ZERO_NUMBER
      ) +
      parseFloat(
        agreementDetails.agreementRateDetails?.perDayRentTax
          ? agreementDetails.agreementRateDetails.perDayRentTax
          : CONSTANTS.ZERO_NUMBER
      );

    if (
      (agreementDetails.agreementRateDetails.isLdwCoverageAllowed ===
        CONSTANTS.STATUS_YES &&
        agreementDetails.agreementRateDetails.coverageStatus ==
          CONSTANTS.STATUS_YES &&
        agreementDetails?.isLDWActionPerformed ==
          undefined) ||
      agreementDetails.isLDWActionPerformed ===
        CONSTANTS.STATUS_YES
    ) {
      calculatePerDayRent +=
        parseFloat(
          agreementDetails.agreementRateDetails?.perDayLdw
            ? agreementDetails.agreementRateDetails.perDayLdw
            : CONSTANTS.ZERO_NUMBER
        ) +
        parseFloat(
          agreementDetails.agreementRateDetails?.perDayLdwTax
            ? agreementDetails.agreementRateDetails.perDayLdwTax
            : CONSTANTS.ZERO_NUMBER
        );
    }

    return calculatePerDayRent;
  };

  useEffect(()=>{
    if(!(Number(carryAmount) > Number(carryRentData.maxCarryAmount))){
      calculateMinimumPayment();
    }
    else{
      setEnableCarryRent(false);
      agreementInfo.setCarryRent(CONSTANTS.ZREO_TWO_DECIMAL_STRING)
      agreementInfo.setPaymentDisable((prev) => ({
        ...prev,
        isValidCarryRent: false,
      }));
      setCarryAmount(CONSTANTS.ZREO_TWO_DECIMAL_STRING)
    }
  },[agreementInfo.carryRentCalci])

  /**
   * PS_CR_36, PS_CR_37, PS_CR_38
   * this function on and off the carry rent toggle button and invoke the calculateMinimumPayment function.
   * @param e
   */

  const handleToggle = (checked: boolean) => {
    const customerInfoClone = JSON.parse(
      JSON.stringify(agreementInfo.customerInfo)
    );

    if (
      checked &&
      carryToggleEnableAndDisable.isAgreementSelected
    ) {
      setEnableCarryRent(true);
      calculateMinimumPayment();
      customerInfoClone.carryRentToggleEnabled = true;
      customerInfoClone.carryRentEnable = true;
    } else {
      setEnableCarryRent(false);
      setCarryRentData({
        minPayment: CONSTANTS.ZERO_TWO_DECIMAL_NUMBER,
        maxCarryAmount: CONSTANTS.ZERO_TWO_DECIMAL_NUMBER,
      });
      setCarryAmount(CONSTANTS.ZREO_TWO_DECIMAL_STRING);
      customerInfoClone.carryRentToggleEnabled = false;
      customerInfoClone.carryRentEnable = false;
      agreementInfo.setCarryRent(CONSTANTS.ZREO_TWO_DECIMAL_STRING);
      agreementInfo.setPaymentDisable((prev) => ({
        ...prev,
        isValidCarryRent: false,
      }));
      agreementInfo.setRenderContext(!agreementInfo.renderContext);
    }
    agreementInfo.setCustomerInfo(customerInfoClone);
  };

  /**
   * PS_CR_33, PS_CR_34
   * This function set state the values into carryAmonut variable
   * @param e
   */

  const onCarryChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    const parseValue = inputValue.replace(
      CONSTANTS.REPLACE_COMMA,
      CONSTANTS.EMPTY_STRING
    );
    
    // Only allow numeric input (including decimal point)
    if (/^\d*\.?\d*$/.test(parseValue)) {
      setCarryAmount(parseValue);
  
      const numericValue = Number(parseValue).toFixed(2);
  
      if (Number(numericValue) > carryRentData.maxCarryAmount) {
        agreementInfo.setCarryRent(CONSTANTS.ZREO_TWO_DECIMAL_STRING);
        agreementInfo.setPaymentDisable((prev) => ({
          ...prev,
          isValidCarryRent: true,
        }));
      } else {
        agreementInfo.setCarryRent(numericValue);
        agreementInfo.setPaymentDisable((prev) => ({
          ...prev,
          isValidCarryRent: false,
        }));
      }
      agreementInfo.setRenderContext(!agreementInfo.renderContext);
    }
  };

  /**
   * PS_CR_34.1
   * this function convert the carryAmount value to two decimal places.
   */

  const carryRentonBlur = () => {
    setCarryAmount(Number(carryAmount).toFixed(2));
  };

  /**
   * PS_CR_23 - PS_CR_32
   * Rac strap binding
   */
  return (
    <>
     {featureFlags.MXStoreIdentifier !== "1" && (
      <RACToggle
        name="Carry Rent"
        GridClassName={`${classes.gridClassToggleReverse} ${classes.carryRentBottom}`}
        labelGridClassName={classes.gridClassLabel}
        checked={
          enableCarryRent && carryToggleEnableAndDisable.isAgreementSelected
        }
        toggleColor="#71CA2F"
        leftText={true}
        disabled={
          carryToggleEnableAndDisable.isPendingAgrTransfer ||
          (carryToggleEnableAndDisable.diffStoreAgreement &&
            carryToggleEnableAndDisable.isRevenueRecogActivated)
        }
        labelClassName={classes.switchLabel}
        leftLabel={t("Carry Rent")}
        OnClick={(e) => {
          handleToggle(e.target.checked);
        }}
      />)}

      {enableCarryRent ? (
        <Grid container data-testid="availcreditid">
          <Grid item className={`${classes.w100} ${classes.floatLeft}`}>
            <Card
              className={`${classes.card} ${classes.w100} ${classes.floatLeft} ${classes.p3}`}
              style={{ marginBottom: '90px' }}
            >
              <CardContent className={classes.p0}>
                <Grid className={`${classes.w100} ${classes.floatLeft}`}>
                  <>
                    <Typography
                      component={'label'}
                      className={`${classes.formLabel}  ${classes.mt3} ${classes.floatLeft}`}
                    >
                    {t("Minimum Payment")}  
                    </Typography>
                    <Box
                      component="span"
                      className={`${classes.labeltxtstyle} ${classes.mt3} ${classes.floatRight} ${classes.textend} `}
                    >
                      $
                      <Box className={`${classes.displayInline}`}>
                        {carryRentData.minPayment < CONSTANTS.ZERO_NUMBER
                          ? CONSTANTS.ZREO_TWO_DECIMAL_STRING
                          : carryRentData.minPayment.toFixed(2)}
                      </Box>
                    </Box>
                  </>
                </Grid>
                <Grid className={`${classes.w100} ${classes.floatLeft}`}>
                  <>
                    <Typography
                      component={'label'}
                      className={`${classes.formLabel}  ${classes.mt3} ${classes.floatLeft}`}
                    >
                     {t("Max. Carry Amount")} 
                    </Typography>
                    <Box
                      component="span"
                      className={`${classes.labeltxtstyle} ${classes.mt3} ${classes.floatRight} ${classes.textend} `}
                    >
                      $
                      <Box className={`${classes.displayInline}`}>
                        {carryRentData.maxCarryAmount <= CONSTANTS.ZERO_NUMBER
                          ? CONSTANTS.ZREO_TWO_DECIMAL_STRING
                          : carryRentData.maxCarryAmount.toFixed(2)}
                      </Box>
                    </Box>
                  </>
                </Grid>
                <Grid className={`${classes.w100} ${classes.floatLeft}`}>
                  <>
                    <Typography
                      component={'label'}
                      className={`${classes.formLabel} ${classes.w35} ${classes.mt3} ${classes.floatLeft}`}
                    >
                     {t("Carry Amount")} 
                    </Typography>
                  </>
                  <Grid
                    item
                    className={`${classes.w50} ${classes.floatRight} ${classes.mt2}`}
                  >
                    <Grid
                      item
                      className={`${classes.inputgroup} ${classes.mb3}`}
                      id="bottom-section"
                    >
                      <span className={classes.inputgrouptext}>$</span>
                      <CurrencyInput
                        className={`${classes.formcontrol3} ${classes.textend}`}
                        value={carryAmount}
                        type="text"
                        id="carryRent"
                        defaultValue={carryRentData.maxCarryAmount}
                        disabled={carryRentAmountDisable}
                        decimalsLimit={2}
                        onChange={(e) => {
                          onCarryChange(e);
                        }}
                        onBlur={() => carryRentonBlur()}
                      />
                    </Grid>
                    {Number(carryAmount) >
                    Number(carryRentData.maxCarryAmount) ? (
                      <Typography
                        component={'label'}
                        className={classes.mandatoryfield}
                      >
                       {t("Amount should not be entered more than the Max.CarryAmount")} 
                      </Typography>
                    ) : null}
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      ) : (
        <></>
      )}
    </>
  );
}
